
import ProductTeaser from '@/components/teasers/ProductTeaser'
export default {
  components: {
    ProductTeaser,
  },

  computed: {
    products() {
      if(!this.$store.state.config.accessories || !this.$store.state.config.accessories.data){
        return []
      }
      return this.$store.state.products.filter((product) => {
        return this.$store.state.config.accessories.data.some((f) => {

          return (
            Number(f.id) ===
            Number(product.id)
          )
          
        })
      })
    },
  }
}
